import React from "react";
import CommonRow from "../common-row";

const FourStoryHalfFeatured = props => {
  return <CommonRow {...props} />;
};

export default FourStoryHalfFeatured;
